import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { Bia } from 'src/app/core/models/bia.model';

export const dummyAction = createAction('[BIA] Dummy');

// LOAD ALL BIA
export const loadAllBias = createAction('[BIA] Load All Bias');
export const loadAllBiasSuccess = createAction(
  '[BIA] Load All Bias Success',
  props<{ bias: any[] }>()
);

// #region BIA RELATED ACTIONS
// LOAD BIA
export const loadBias = createAction(
  '[BIA] Load Bias',
  props<{ options: any }>()
);
export const loadBiasSuccess = createAction(
  '[BIA] Load Bias Success',
  props<{ bias: Bia[] }>()
);
export const loadBiasFailure = createAction(
  '[BIA] Load Bias Failure',
  props<{ error: any }>()
);
// ADD BIA
export const addBia = createAction('[BIA] Add Bia', props<{ bia: Bia }>());
export const addBiaSuccess = createAction(
  '[BIA] Add Bia Success',
  props<{ bia: Bia }>()
);
// UPDATE BIA
export const updateBia = createAction(
  '[BIA] Update Bia',
  props<{ bia: Bia }>()
);
export const updateBiaSuccess = createAction(
  '[BIA] Update Bia Success',
  props<{ bia: Update<Bia> }>()
);
// DELETE BIA
export const deleteBia = createAction(
  '[BIA] Delete Bia',
  props<{ id: number }>()
);
export const deleteBiaSuccess = createAction(
  '[BIA] Delete Bia Success',
  props<{ id: number }>()
);
//#endregion

// #region CALLTREE AND APPLICABLE CALLTREE
// CALLTREE
// LOAD
export const loadCallTree = createAction(
  '[BIA CT] Load CallTree',
  props<{ id: number }>()
);
export const loadCallTreeMultiple = createAction(
  '[BIA CT] Load CallTree Multiple',
  props<{ ids: number[] }>()
);
export const loadCallTreeSuccess = createAction(
  '[BIA CT] Load CallTree Success',
  props<{ id: number; callTreeList: any }>()
);
// UPDATE CALLTREE
export const adjustAppCallTree = createAction(
  '[BIA CT] Update CallTree',
  props<{ id: number; appCallTreeList: any }>()
);
export const updateAppCallTreeSuccess = createAction(
  '[BIA CT] Update CallTree Success',
  props<{ id: number; appCallTreeList: any }>()
);

// APPLICABLE CALLTREE
// LOAD
export const loadApplicableCallTree = createAction(
  '[BIA ACT] Load Applicable CallTree',
  props<{ id: number }>()
);
export const loadApplicableCallTreeSuccess = createAction(
  '[BIA ACT] Load Applicable CallTree Success',
  props<{ id: number; callTreeList: any }>()
);
//#endregion

// #region LOCATIONS
// LOAD
export const loadLocation = createAction(
  '[BIA Location] Load Location',
  props<{ id: number }>()
);
export const loadLocationSuccess = createAction(
  '[BIA Location] Load Location Success',
  props<{ id: number; locations: any }>()
);
//#endregion

// #region PROCESS
// LOAD
export const loadProcesses = createAction(
  '[BIA Process] Load Process',
  props<{ id: number }>()
);
export const loadProcessesSuccess = createAction(
  '[BIA Process] Load Process Success',
  props<{ id: number; processes: any }>()
);
// ADD BIA
export const addProcess = createAction(
  '[BIA Process] Add Process',
  props<{ id: number; process: any }>()
);
export const addProcessSuccess = createAction(
  '[BIA Process] Add Process Success',
  props<{ id: number; process: any }>()
);
// UPDATE BIA
export const updateProcess = createAction(
  '[BIA Process] Update Process',
  props<{ id: number; process: any }>()
);
export const updateProcessSuccess = createAction(
  '[BIA Process] Update Process Success',
  props<{ id: number; process: any }>()
);
// DELETE BIA
export const deleteProcess = createAction(
  '[BIA Process] Delete Process',
  props<{ id: number; processId: number }>()
);
export const deleteProcessSuccess = createAction(
  '[BIA Process] Delete Process Success',
  props<{ id: number; processId: number }>()
);
//#endregion

// #region INTERNAL DEPENDENCY
// LOAD
export const loadInDependencies = createAction(
  '[BIA InDependency] Load InDependency',
  props<{ id: number }>()
);
export const loadInDependenciesSuccess = createAction(
  '[BIA InDependency] Load InDependency Success',
  props<{ id: number; inDependencies: any }>()
);
// ADD BIA
export const addInDependency = createAction(
  '[BIA InDependency] Add InDependency',
  props<{ id: number; inDependency: any }>()
);
export const addInDependencySuccess = createAction(
  '[BIA InDependency] Add InDependency Success',
  props<{ id: number; inDependency: any }>()
);
// UPDATE BIA
export const updateInDependency = createAction(
  '[BIA InDependency] Update InDependency',
  props<{ id: number; inDependency: any }>()
);
export const updateInDependencySuccess = createAction(
  '[BIA InDependency] Update InDependency Success',
  props<{ id: number; inDependency: any }>()
);
// DELETE BIA
export const deleteInDependency = createAction(
  '[BIA InDependency] Delete InDependency',
  props<{ id: number; inDependencyId: number }>()
);
export const deleteInDependencySuccess = createAction(
  '[BIA InDependency] Delete InDependency Success',
  props<{ id: number; inDependencyId: number }>()
);
//#endregion

// #region EXTERNAL DEPENDENCY
// LOAD
export const loadExDependencies = createAction(
  '[BIA ExDependency] Load ExDependency',
  props<{ id: number; options?: any }>()
);
export const loadExDependenciesSuccess = createAction(
  '[BIA ExDependency] Load ExDependency Success',
  props<{ id: number; exDependencies: any }>()
);
// ADD BIA
export const addExDependency = createAction(
  '[BIA ExDependency] Add ExDependency',
  props<{ id: number; exDependency: any }>()
);
export const addExDependencySuccess = createAction(
  '[BIA ExDependency] Add ExDependency Success',
  props<{ id: number; exDependency: any }>()
);
// UPDATE BIA
export const updateExDependency = createAction(
  '[BIA ExDependency] Update ExDependency',
  props<{ id: number; exDependency: any }>()
);
export const updateExDependencySuccess = createAction(
  '[BIA ExDependency] Update ExDependency Success',
  props<{ id: number; exDependency: any }>()
);
// DELETE BIA
export const deleteExDependency = createAction(
  '[BIA ExDependency] Delete ExDependency',
  props<{ id: number; exDependencyId: number }>()
);
export const deleteExDependencySuccess = createAction(
  '[BIA ExDependency] Delete ExDependency Success',
  props<{ id: number; exDependencyId: number }>()
);
//#endregion

// #region IMPACT
// LOAD
export const loadImpact = createAction(
  '[BIA Impact] Load Impact',
  props<{ id: number }>()
);
export const loadImpactSuccess = createAction(
  '[BIA Impact] Load Impact Success',
  props<{ id: number; impact: any }>()
);

// ADD BIA
export const addOrUpdateImpact = createAction(
  '[BIA Impact] Add or Update Impact',
  props<{ id: number; impact: any }>()
);
export const addOrUpdateImpactSuccess = createAction(
  '[BIA Impact] Add or Update Impact Success',
  props<{ id: number; impact: any }>()
);
//#endregion

// #region RESOURCES
// Resources -> Staff Requirement
// LOAD
export const loadStaffReq = createAction(
  '[BIA Staff Req] Load Staff Req',
  props<{ id: number }>()
);
export const loadStaffReqSuccess = createAction(
  '[BIA Staff Req] Load Staff Req Success',
  props<{ id: number; staffRequirements: any }>()
);
// ADD
export const addStaffReq = createAction(
  '[BIA Staff Req] Add Staff Req',
  props<{ id: number; staffRequirement: any }>()
);
export const addStaffReqSuccess = createAction(
  '[BIA Staff Req] Add Staff Req Success',
  props<{ id: number; staffRequirement: any }>()
);
// UPDATE
export const updateStaffReq = createAction(
  '[BIA Staff Req] Update Staff Req',
  props<{ id: number; staffRequirement: any }>()
);
export const updateStaffReqSuccess = createAction(
  '[BIA Staff Req] Update Staff Req Success',
  props<{ id: number; staffRequirement: any }>()
);
// DELETE
export const deleteStaffReq = createAction(
  '[BIA Staff Req] Delete Staff Req',
  props<{ id: number; staffReqId: number }>()
);
export const deleteStaffReqSuccess = createAction(
  '[BIA Staff Req] Delete Staff Req Success',
  props<{ id: number; staffReqId: number }>()
);

// Resources -> Vital Record
// LOAD
export const loadVitalRecord = createAction(
  '[BIA Vital Record] Load VR',
  props<{ id: number }>()
);
export const loadVitalRecordSuccess = createAction(
  '[BIA Vital Record] Load VR Success',
  props<{ id: number; vitalRecords: any }>()
);
// ADD
export const addVitalRecord = createAction(
  '[BIA Vital Record] Add VR',
  props<{ id: number; vitalRecord: any }>()
);
export const addVitalRecordSuccess = createAction(
  '[BIA Vital Record] Add VR Success',
  props<{ id: number; vitalRecord: any }>()
);
// UPDATE
export const updateVitalRecord = createAction(
  '[BIA Vital Record] Update VR',
  props<{ id: number; vitalRecord: any }>()
);
export const updateVitalRecordSuccess = createAction(
  '[BIA Vital Record] Update VR Success',
  props<{ id: number; vitalRecord: any }>()
);
// DELETE
export const deleteVitalRecord = createAction(
  '[BIA Vital Record] Delete VR',
  props<{ id: number; vitalRecordId: number }>()
);
export const deleteVitalRecordSuccess = createAction(
  '[BIA Vital Record] Delete VR Success',
  props<{ id: number; vitalRecordId: number }>()
);

// Resources -> Applications & Softwares
// LOAD
export const loadAppNSoft = createAction(
  '[BIA App & Softs] Load AppNSoft',
  props<{ id: number }>()
);
export const loadAppNSoftSuccess = createAction(
  '[BIA App & Softs] Load AppNSoft Success',
  props<{ id: number; appNSofts: any }>()
);
// ADD
export const addAppNSoft = createAction(
  '[BIA App & Softs] Add AppNSoft',
  props<{ id: number; appNSoft: any }>()
);
export const addAppNSoftSuccess = createAction(
  '[BIA App & Softs] Add AppNSoft Success',
  props<{ id: number; appNSoft: any }>()
);
// UPDATE
export const updateAppNSoft = createAction(
  '[BIA App & Softs] Update AppNSoft',
  props<{ id: number; appNSoft: any }>()
);
export const updateAppNSoftSuccess = createAction(
  '[BIA App & Softs] Update AppNSoft Success',
  props<{ id: number; appNSoft: any }>()
);
// DELETE
export const deleteAppNSoft = createAction(
  '[BIA App & Softs] Delete AppNSoft',
  props<{ id: number; appNSoftId: number }>()
);
export const deleteAppNSoftSuccess = createAction(
  '[BIA App & Softs] Delete AppNSoft Success',
  props<{ id: number; appNSoftId: number }>()
);

// Resources -> IT Infrastructure Required
// LOAD
export const loadITInfra = createAction(
  '[BIA IT Infra Required] Load ITInfra',
  props<{ id: number }>()
);
export const loadITInfraSuccess = createAction(
  '[BIA IT Infra Required] Load ITInfra Success',
  props<{ id: number; iTInfras: any }>()
);
// ADD
export const addITInfra = createAction(
  '[BIA IT Infra Required] Add ITInfra',
  props<{ id: number; iTInfra: any }>()
);
export const addITInfraSuccess = createAction(
  '[BIA IT Infra Required] Add ITInfra Success',
  props<{ id: number; iTInfra: any }>()
);
// UPDATE
export const updateITInfra = createAction(
  '[BIA IT Infra Required] Update ITInfra',
  props<{ id: number; iTInfra: any }>()
);
export const updateITInfraSuccess = createAction(
  '[BIA IT Infra Required] Update ITInfra Success',
  props<{ id: number; iTInfra: any }>()
);
// DELETE
export const deleteITInfra = createAction(
  '[BIA IT Infra Required] Delete ITInfra',
  props<{ id: number; iTInfraId: number }>()
);
export const deleteITInfraSuccess = createAction(
  '[BIA IT Infra Required] Delete ITInfra Success',
  props<{ id: number; iTInfraId: number }>()
);

// Resources -> Special Requirement
// LOAD
export const loadSplReq = createAction(
  '[BIA Special Req] Load SplReq',
  props<{ id: number }>()
);
export const loadSplReqSuccess = createAction(
  '[BIA Special Req] Load SplReq Success',
  props<{ id: number; splReqs: any }>()
);
// ADD
export const addSplReq = createAction(
  '[BIA Special Req] Add SplReq',
  props<{ id: number; splReq: any }>()
);
export const addSplReqSuccess = createAction(
  '[BIA Special Req] Add SplReq Success',
  props<{ id: number; splReq: any }>()
);
// UPDATE
export const updateSplReq = createAction(
  '[BIA Special Req] Update SplReq',
  props<{ id: number; splReq: any }>()
);
export const updateSplReqSuccess = createAction(
  '[BIA Special Req] Update SplReq Success',
  props<{ id: number; splReq: any }>()
);
// DELETE
export const deleteSplReq = createAction(
  '[BIA Special Req] Delete SplReq',
  props<{ id: number; splReqId: number }>()
);
export const deleteSplReqSuccess = createAction(
  '[BIA Special Req] Delete SplReq Success',
  props<{ id: number; splReqId: number }>()
);
//#endregion

// #region PEAKTIMES & CRITICAL DEADLINES
// PEAK TIMES
// LOAD
export const loadPeakTime = createAction(
  '[BIA PeakTime] Load PeakTime',
  props<{ id: number }>()
);
export const loadPeakTimeSuccess = createAction(
  '[BIA PeakTime] Load PeakTime Success',
  props<{ id: number; peakTimes: any }>()
);
// ADD BIA
export const addPeakTime = createAction(
  '[BIA PeakTime] Add PeakTime',
  props<{ id: number; peakTime: any }>()
);
export const addPeakTimeSuccess = createAction(
  '[BIA PeakTime] Add PeakTime Success',
  props<{ id: number; peakTime: any }>()
);
// DELETE BIA
export const deletePeakTime = createAction(
  '[BIA PeakTime] Delete PeakTime',
  props<{ id: number; peakTimeId: number }>()
);
export const deletePeakTimeSuccess = createAction(
  '[BIA PeakTime] Delete PeakTime Success',
  props<{ id: number; peakTimeId: number }>()
);

// CRITICAL DEADLINES
// LOAD
export const loadCriticalDeadline = createAction(
  '[BIA CriticalDeadline] Load CD',
  props<{ id: number }>()
);
export const loadCriticalDeadlineSuccess = createAction(
  '[BIA CriticalDeadline] Load CD Success',
  props<{ id: number; cds: any }>()
);
// ADD BIA
export const addCriticalDeadline = createAction(
  '[BIA CriticalDeadline] Add CD',
  props<{ id: number; cd: any }>()
);
export const addCriticalDeadlineSuccess = createAction(
  '[BIA CriticalDeadline] Add CD Success',
  props<{ id: number; cd: any }>()
);
// DELETE BIA
export const deleteCriticalDeadline = createAction(
  '[BIA CriticalDeadline] Delete CD',
  props<{ id: number; cdId: number }>()
);
export const deleteCriticalDeadlineSuccess = createAction(
  '[BIA CriticalDeadline] Delete CD Success',
  props<{ id: number; cdId: number }>()
);
//#endregion

// #region ADDITIONAL INFORMATION
// LOAD
export const loadAdInfo = createAction(
  '[BIA AdInfo] Load AdInfo',
  props<{ id: number }>()
);
export const loadAdInfoSuccess = createAction(
  '[BIA AdInfo] Load AdInfo Success',
  props<{ id: number; adInfoes: any }>()
);
// ADD BIA
export const addOrUpdateAdInfo = createAction(
  '[BIA AdInfo] Add or Update AdInfo',
  props<{ id: number; adInfo: any }>()
);
export const addOrUpdateAdInfoSuccess = createAction(
  '[BIA AdInfo] Add or Update AdInfo Success',
  props<{ id: number; adInfo: any }>()
);
//#endregion

//#region SPOF
// LOAD
export const loadSpof = createAction(
  '[BIA SPOF] Load SPOF',
  props<{ id: number }>()
);
export const loadSpofSuccess = createAction(
  '[BIA SPOF] Load SPOF Success',
  props<{ id: number; spof: any }>()
);

export const addOrUpdateSpof = createAction(
  '[BIA SPOF] Add or Update SPOF',
  props<{ id: number; spof: any }>()
);
export const addOrUpdateSpofSuccess = createAction(
  '[BIA SPOF] Add or Update SPOF Success',
  props<{ id: number; spof: any }>()
);
//#endregion

// Resources -> HR
// LOAD
export const loadHR = createAction('[BIA HR] Load HR', props<{ id: number }>());
export const loadHRSuccess = createAction(
  '[BIA HR] Load HR Success',
  props<{ id: number; hrs: any }>()
);
// ADD
export const addHR = createAction(
  '[BIA HR] Add HR',
  props<{ id: number; hr: any }>()
);
export const addHRSuccess = createAction(
  '[BIA HR] Add HR Success',
  props<{ id: number; hr: any }>()
);
// UPDATE
export const updateHR = createAction(
  '[BIA HR] Update HR',
  props<{ id: number; hr: any }>()
);
export const updateHRSuccess = createAction(
  '[BIA HR] Update HR Success',
  props<{ id: number; hr: any }>()
);
// DELETE
export const deleteHR = createAction(
  '[BIA HR] Delete HR',
  props<{ id: number; hr: number }>()
);
export const deleteHRSuccess = createAction(
  '[BIA HR] Delete HR Success',
  props<{ id: number; hr: number }>()
);

// Resources -> Call Tree
// LOAD
export const loadResourceCallTree = createAction(
  '[BIA ResourceCallTree] Load ResourceCallTree',
  props<{ id: number }>()
);
export const loadResourceCallTreeSuccess = createAction(
  '[BIA ResourceCallTree] Load ResourceCallTree Success',
  props<{ id: number; resourceCallTree: any }>()
);
// ADD
export const addResourceCallTree = createAction(
  '[BIA ResourceCallTree] Add ResourceCallTree',
  props<{ id: number; resourceCallTree: any }>()
);
export const addResourceCallTreeSuccess = createAction(
  '[BIA ResourceCallTree] Add ResourceCallTree Success',
  props<{ id: number; resourceCallTree: any }>()
);
// UPDATE
export const updateResourceCallTree = createAction(
  '[BIA ResourceCallTree] Update ResourceCallTree',
  props<{ id: number; resourceCallTree: any }>()
);
export const updateResourceCallTreeSuccess = createAction(
  '[BIA ResourceCallTree] Update ResourceCallTree Success',
  props<{ id: number; resourceCallTree: any }>()
);
// DELETE
export const deleteResourceCallTree = createAction(
  '[BIA ResourceCallTree] Delete ResourceCallTree',
  props<{ id: number; resourceCallTree: number }>()
);
export const deleteResourceCallTreeSuccess = createAction(
  '[BIA ResourceCallTree] Delete ResourceCallTree Success',
  props<{ id: number; resourceCallTree: number }>()
);

// BIA_INTRO
// LOAD
export const loadBiaIntro = createAction(
  '[BIA BiaIntro] Load BiaIntro',
  props<{ biaId: number }>()
);
export const loadBiaIntroSuccess = createAction(
  '[BIA BiaIntro] Load BiaIntro Success',
  props<{ biaId: number; biaIntro: any }>()
);
// ADD BIA
export const addOrUpdateBiaIntro = createAction(
  '[BIA BiaIntro] Add or Update BiaIntro',
  props<{ id: number; biaIntro: any }>()
);
export const addOrUpdateBiaIntroSuccess = createAction(
  '[BIA BiaIntro] Add or Update BiaIntro Success',
  props<{ id: number; biaIntro: any }>()
);
//#endregion
